// ** Redux Imports
import { combineReducers } from 'redux';

// ** Reducers Imports
import users from './users';
import cities from './cities';
import areas from './areas';
import deliveryCosts from './delivery-costs';
import deliveryFees from './delivery-fees';
import warehouses from './warehouses';
import promocodes from './promocodes';
import services from './services';
import addresses from './addresses';
import merchants from './merchants';
import workflows from './workflows';
import loyaltyPointsConsumption from './loyalty-points-consumption';
import statuses from './statuses';
import nextStatuses from './next-statuses';
import charges from './charges';
import invoices from './invoices';
import nonworkingDays from './nonworking-days';
import orders, { orderValueHistory } from './orders';
import orderEvents from './order-events';
import returnInvoices from './return-invoices';
import transferRequests from './transfer-requests';
import transactions from './transactions';

const adminReducer = combineReducers({
  users,
  cities,
  areas,
  deliveryCosts,
  merchants,
  addresses,
  deliveryFees,
  warehouses,
  promocodes,
  services,
  loyaltyPointsConsumption,
  workflows,
  statuses,
  nextStatuses,
  charges,
  invoices,
  nonworkingDays,
  orders,
  orderEvents,
  returnInvoices,
  orderValueHistory,
  transferRequests,
  transactions,
});

export default adminReducer;
